export default function GalleryHero() {
  return (
    <section className="relative h-[400px] md:h-[500px] flex items-center overflow-hidden bg-[#1B2A4A]">
      <div className="absolute inset-0 bg-gradient-to-r from-[#1B2A4A] via-[#1B2A4A]/90 to-[#1B2A4A]/80"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8">
        <nav className="flex items-center gap-2 text-white/70 text-sm mb-6">
          <a href="/" className="hover:text-white transition-colors cursor-pointer">Home</a>
          <i className="ri-arrow-right-s-line text-[#7FBF3F]"></i>
          <span className="text-white font-medium">Gallery</span>
        </nav>

        <div className="max-w-xl">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white/80 text-xs font-medium px-4 py-1.5 rounded-full mb-5">
            <i className="ri-image-2-line"></i>Project Visuals &amp; Site Photography
          </div>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5" style={{ fontFamily: "'Playfair Display', serif" }}>
            Gallery
          </h1>
          <p className="text-white/85 text-base md:text-lg leading-relaxed mb-8">
            Explore project visuals and premium developments by Urban Infra on Sarjapur Road, Bengaluru.
          </p>
          <div className="flex flex-wrap gap-4">
            <a href="#gallery-grid" className="inline-flex items-center gap-2 bg-[#7FBF3F] hover:bg-[#6aaa32] text-white text-sm font-semibold px-6 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-gallery-line"></i>Browse Gallery
            </a>
            <a href="/contact" className="inline-flex items-center gap-2 border-2 border-white/50 text-white hover:bg-white/10 text-sm font-semibold px-6 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-calendar-check-line"></i>Book a Site Visit
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
